// Free Snap Landing Page — Storefront API checkout bypass
// Creates an isolated cart via Shopify's Storefront API, completely separate
// from the main site cart, then redirects straight to checkout.

(function () {
    const formSection = document.querySelector('#freesnap-form');

    // ── Claim button → scroll to form ─────────────────────────────────────────
    function scrollToForm() {
        if (!formSection) return;
        formSection.scrollIntoView({ behavior: 'smooth' });
        // setTimeout(() => formSection.querySelector('input[type="email"]')?.focus(), 500);
    }

    document.querySelectorAll('.btn.claim').forEach(btn => {
        btn.addEventListener('click', e => { e.preventDefault(); scrollToForm(); });
    });

    // ── Mast / wave sizing ────────────────────────────────────────────────────
    const mastGroup = document.querySelector('.mast-group');
    if (mastGroup) {
        let busy = false;
        const snapWave = () => {
            if (busy) return;
            busy = true;
            mastGroup.style.height = '';
            const { width, height } = mastGroup.getBoundingClientRect();
            mastGroup.style.height = Math.ceil(height / 2) * 2 + 'px';
            const frac = (width / 2) % 1;
            mastGroup.style.setProperty('--wave-nudge', frac < 0.01 ? '0px' : (1 - frac) + 'px');
            requestAnimationFrame(() => { busy = false; });
        };
        snapWave();
        new ResizeObserver(snapWave).observe(mastGroup);

        new IntersectionObserver(([entry]) => {
            document.documentElement.classList.toggle('mast-visible', entry.isIntersecting);
        }).observe(mastGroup);

        if (formSection) {
            new IntersectionObserver(([entry]) => {
                document.documentElement.classList.toggle('form-visible', entry.isIntersecting);
            }).observe(formSection);
        }
    }

    // ── Form handling ─────────────────────────────────────────────────────────
    const config = document.querySelector('#freesnap-data');
    if (!config) return;

    document.querySelectorAll('form.freesnap-form').forEach(form => bindForm(form));

    function bindForm(form) {
        form.addEventListener('submit', e => {
            e.preventDefault();
            handleSubmit(form);
        });
        form.querySelector('.submit-btn')?.addEventListener('click', () => handleSubmit(form));
    }

    async function handleSubmit(form) {
        const emailInput = form.querySelector('[name="email"]');
        const cityInput  = form.querySelector('[name="city"]');
        const stateInput = form.querySelector('[name="state"]');
        const ageBox     = form.querySelector('[name="age-confirm"]');
        const btn        = form.querySelector('.submit-btn');

        const email = emailInput?.value?.trim() || '';
        const city  = cityInput?.value?.trim() || '';
        const state = stateInput?.value?.trim().toUpperCase() || '';

        if (!email) {
            setFormState(form, 'error', 'Please enter your email address.');
            emailInput?.focus();
            return;
        }
        if (!city) {
            setFormState(form, 'error', 'Please enter your city.');
            cityInput?.focus();
            return;
        }
        if (!state) {
            setFormState(form, 'error', 'Please enter your state.');
            stateInput?.focus();
            return;
        }
        if (!ageBox?.checked) {
            setFormState(form, 'error', 'Please confirm you are over 21 years of age.');
            return;
        }

        setFormState(form, null, '');
        btn?.classList.add('loading');

        // Capture in Klaviyo opportunistically — non-blocking, failure is silent.
        captureEmail(email, city, state).catch(() => {});

        const checkoutUrl = await createCart(email, city, state);

        if (!checkoutUrl) {
            btn?.classList.remove('loading');
            setFormState(form, 'error', 'Something went wrong. Please try again.');
            return;
        }

        window.location.href = checkoutUrl;
    }

    async function createCart(email, city, state) {
        const token     = config.dataset.storefrontToken;
        const variantId = config.dataset.variantId;

        if (!token || !variantId || variantId === 'gid://shopify/ProductVariant/') {
            console.warn('Hi-Snaps Free Snap: storefront token or variant ID not configured.');
            return null;
        }

        const buyerIdentity = { email };
        if (city || state) {
            buyerIdentity.deliveryAddressPreferences = [{
                deliveryAddress: {
                    ...(city  && { city }),
                    ...(state && { province: state }),
                    country: 'US',
                },
            }];
        }

        const mutation = `
            mutation cartCreate($input: CartInput!) {
                cartCreate(input: $input) {
                    cart { checkoutUrl }
                    userErrors { field message }
                }
            }
        `;

        try {
            const res = await fetch('/api/2024-10/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': token,
                },
                body: JSON.stringify({
                    query: mutation,
                    variables: {
                        input: {
                            buyerIdentity,
                            lines: [{ merchandiseId: variantId, quantity: 1 }],
                        },
                    },
                }),
            });

            const data = await res.json();
            const errors = data?.data?.cartCreate?.userErrors;

            if (errors?.length) {
                console.error('Free Snap cart errors:', errors);
                return null;
            }

            return data?.data?.cartCreate?.cart?.checkoutUrl || null;
        } catch (err) {
            console.error('Free Snap cart creation failed:', err);
            return null;
        }
    }

    async function captureEmail(email, city, state) {
        if (window.HiSnaps?.email?.submitToKlaviyo) {
            const key  = config.dataset.klaviyoKey;
            const list = config.dataset.klaviyoList;
            if (key && list) {
                await window.HiSnaps.email.submitToKlaviyo(email, null, {
                    klaviyoKey: key,
                    listId: list,
                    customSource: 'freesnap_landing',
                    customProperties: {
                        freesnap_request: true,
                        ...(city  && { freesnap_city: city }),
                        ...(state && { freesnap_state: state }),
                    },
                });
            }
        }
    }

    function setFormState(form, state, message) {
        const msgEl = form.querySelector('.form-message');
        if (msgEl) msgEl.textContent = message || '';

        form.classList.remove('error');
        if (state === 'error') {
            form.classList.add('error');
            setTimeout(() => form.classList.remove('error'), 5000);
        }
    }
}());
